import React, {useEffect, useState} from "react";

export default function WarningDialog(){
    const [show, setShow] = useState(true)

    useEffect(() => {
        const timeId = setTimeout(() => {
            // After 3 seconds set the show value to false
            setShow(false)
        }, 10000)

        return () => {
            clearTimeout(timeId)
        }
    }, []);

    // If show is false the component will return null and stop here
    if (!show) {
        return null;
    }

    // If show is true this will be returned
    return (
        <div className="warning-dialog" onClick={() => setShow(false)}>
            <div className="dialog-content">
                <button className="close-button" onClick={() => setShow(false)}> &times;</button>
                <h4>PERINGATAN!</h4>
                <p>HATI-HATI, TRANSAKSI INI <b><em>BERISIKO TINGGI</em></b>. ANDA DAPAT SAJA MENGALAMI KERUGIAN ATAU KEHILANGAN UANG. JANGAN BERUTANG JIKA TIDAK MEMILIKI KEMAMPUAN MEMBAYAR. PERTIMBANGKAN SECARA BIJAK SEBELUM BERTRANSAKSI.</p>
            </div>
        </div>
    );
}